import { useContext } from "react";
import { observer } from "mobx-react";
import { OrganizationStubVolunteerLinking } from "../../../../stores/models/OrganizationStubVolunteerLinking";
import { StepProps } from "../../../../stores/models/Step";
import { RootContext } from "../../../../stores";
import VerifyCorrectAccount from "../VerifyCorrectAccount";

const VerifyCorrectAccountStep = observer((props: StepProps<OrganizationStubVolunteerLinking>) => {

    const rootStore = useContext(RootContext);
    const user = rootStore.userStore.user;
    const volunteer = props.stepState.stepObject.linkDetails.volunteer;

    /***** Event handlers *****/

    const onLogoutClicked = async () => {
        props.stepState.setLoading(true);
        await rootStore.userStore.logout();
        props.stepState.setLoading(false);
    }

    const onConfirmed = async () => {
        // Set volunteer profile as active profile
        if (!user.isVolunteerProfileActive) {
            await switchToVolunteerProfile();
        }
        props.stepState.setCompleted(true);
    }

    /***** Helper methods *****/

    const switchToVolunteerProfile = async () => {
        const userVolunteerProfile = user.volunteerProfile;
        if (userVolunteerProfile?.id !== undefined) {
            await rootStore.userStore.updateUserProfileStatus(user.id, userVolunteerProfile.id, 'active');
        }
    }
    
    /***** Render *****/

    return (
        <VerifyCorrectAccount
            email={user.email}
            usersName={user.volunteerProfile?.identity.fullName || ''}
            prompt={`Does this account belong to ${volunteer.firstName} ${volunteer.lastName}?`}
            onLogoutClicked={onLogoutClicked}
            onConfirmed={onConfirmed}
        />
    );
});

export default VerifyCorrectAccountStep;